import { bubEvents } from 'shared/events/bub_events';

$(document).ready(() => {
  $('.checkout-auth-link .auth-link').click(() => {
    bubEvents.track('Checkout auth link', 'Clicked link', {
      label: 'Sign in text',
    });
  });

  $('.auth-link').click(e => {
    const authAction = $(e.currentTarget).data('authaction');
    const focusField = $(e.currentTarget).data('focus');
    const headerText = $(e.currentTarget).data('header');

    $('.auth-form').addClass('hidden');
    $(`.${authAction}-form-wrapper`).removeClass('hidden');

    $('.checkout-auth-header').removeClass('selected');
    $(`#${authAction}-header`).addClass('selected');
    $('.checkout-header').text(headerText);

    $(focusField).focus();
  });
});
